module.exports = __webpack_public_path__ + "img/mezze.a5824c9b.png";